import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritGameMode} from "../../server/TrueGritGameMode";
import {gsap, TimelineMax} from "gsap";

/**
 * Created by Jerker Nord on 2021-09-14.
 */

export class TrueGritTotalWinRunner implements SimplePresentation {

    private _totalBetWays:number = 0;
    private _mainTL:TimelineMax;
    private _controller:SimplePresentationRunnerController;

    constructor() {
    }

    shouldRun():boolean {
        for(let i:number = 0; i < TrueGrit.model.gameData.betWayWins.length; i++) {
            this._totalBetWays += TrueGrit.model.gameData.betWayWins[i].numberOfCombinations;
        }

        if((TrueGritGameMode.isEndOfAvalanche(TrueGrit.model.gameData.mode, TrueGrit.model.gameData.nextMode) && TrueGrit.model.winRatio < 15)) {
            return true;
        }
        if(TrueGritGameMode.isEndOfAvalanche(TrueGrit.model.gameData.mode, TrueGrit.model.gameData.nextMode)) {
            //Set to 0 if it's a Big Win
            this._totalBetWays = 0;
            return false;
        } else {
            return false;
        }
    }

    start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        const delayTL:gsap.core.Timeline = new gsap.core.Timeline({delay : 0.35});
        delayTL.add(() => {
            TrueGrit.trueGritGritGirlSymbols.goBackAllToOffState();

            this._mainTL = gsap.timeline();
            this._mainTL.add([
                TrueGrit.totalWinView.getTotalWinTimeline(TrueGrit.model.gameData.accumulatedRoundWin, this._totalBetWays, () => this.complete()),
                this._mainTL.add(() => this._controller.setSkipCallback(() => this.skip()))
            ]);
        })
    }

    private skip():void {
        TrueGrit.totalWinView.hardAbort();
    }

    private complete():void {
        this._totalBetWays = 0;
        this._controller.finish();
    }

    set totalBetWays(value:number) {
        this._totalBetWays = value;
    }
}